import { build2xResponsiveImage } from '../shared/imagehelper';
import imageZoom from '../shared/imagezoom';

const IMAGE_WIDTH = 396;
const THUMBNAIL_WIDTH = 96;

class ImageControlLarge {
    constructor($container, productClassViewModel) {
        if (!$container || !productClassViewModel) {
            throw new Error('ImageControlLarge was called without required parameters');
        }

        const $fragment = document.createDocumentFragment(),
            $parentContainer = document.getElementById('pc-top-content'),
            largeOptions = {
                height: $parentContainer ? $parentContainer.offsetHeight : null
            };

        this.viewmodel = productClassViewModel;
        this.$container = $container;
        this.selectedImage = this.viewmodel.selectedImage()
            ? this.viewmodel.selectedImage()
            : this.viewmodel.carouselImages[0];

        this.$selectedContainer = document.createElement('div');
        this.$selectedContainer.classList.add('image-control-selected');

        this.$zoomable = document.createElement('a');

        this.$zoomable.href = '#';
        this.$zoomable.classList.add('zoomable');
        this.$zoomable.setAttribute('aria-label', 'View larger image');

        if ($container.firstElementChild && $container.firstElementChild.nodeName === 'IMG' && $container.firstElementChild.getAttribute('src').includes(this.selectedImage.url())) {
            this.$selectedImage = $container.firstElementChild;
            this.$selectedImage.dataset.image = this.$selectedImage.src.split('?')[0];
        } else {
            this.$selectedImage = document.createElement('img');
            this.setSelectedImage(this.selectedImage.url());
        }

        this.$selectedImage.width = IMAGE_WIDTH;
        this.$selectedImage.height = IMAGE_WIDTH;
        this.$selectedImage.alt = '';

        this.$zoomable.appendChild(this.$selectedImage);
        this.$selectedContainer.appendChild(this.$zoomable);

        $fragment.appendChild(this.$selectedContainer);

        this.$thumbnails = document.createElement('div');
        this.$thumbnails.classList.add('image-control-thumbnails');

        this.viewmodel.carouselImages.forEach(image => {
            const $thumbLink = document.createElement('a');
            const url = image.url();
            const $image = build2xResponsiveImage({
                url,
                width: THUMBNAIL_WIDTH,
                height: THUMBNAIL_WIDTH,
                alt: '',
                lazy: true
            });

            $thumbLink.dataset.url = url;
            $thumbLink.href = '#';
            $thumbLink.setAttribute('aria-label', 'Show product image');

            $thumbLink.appendChild($image);

            this.$thumbnails.appendChild($thumbLink);
            $thumbLink.addEventListener('click', event => this.handleClick(event), true);
        });

        $fragment.appendChild(this.$thumbnails);

        if (this.viewmodel.carouselImages.length) {
            this.$prev = document.createElement('button');
            this.$prev.classList.add('image-control-prev');
            this.$prev.setAttribute('aria-label', 'Previous Image');
            this.$selectedContainer.appendChild(this.$prev);

            this.$prev.addEventListener('click', e => this.handlePrevClick(e));

            this.$next = document.createElement('button');
            this.$next.classList.add('image-control-next');
            this.$next.setAttribute('aria-label', 'Next Image');
            this.$selectedContainer.appendChild(this.$next);

            this.$next.addEventListener('click', e => this.handleNextClick(e));
        }

        this.$container.innerHTML = '';
        this.$container.appendChild($fragment);

        this.zoom = imageZoom.init(this.$container, largeOptions);

        this.selectedImageSubscription = productClassViewModel.selectedImage.subscribe(image =>
            this.setSelectedImage(image.url())
        );
    }

    handleClick(e) {
        e.preventDefault();
        this.setSelectedImage(e.currentTarget.dataset.url);
        this.viewmodel.selectedImage(
            this.viewmodel.carouselImages.find(img => img.url() === e.currentTarget.dataset.url)
        );
    }

    handleNextClick(e) {
        e.preventDefault();
        const index = this.getSelectedIndex();
        this.viewmodel.selectedImage(
            this.viewmodel.carouselImages[index === this.viewmodel.carouselImages.length - 1 ? 0 : index + 1]
        );
    }

    handlePrevClick(e) {
        e.preventDefault();
        const index = this.getSelectedIndex();
        this.viewmodel.selectedImage(
            this.viewmodel.carouselImages[index === 0 ? this.viewmodel.carouselImages.length - 1 : index - 1]
        );
    }

    getSelectedIndex() {
        return this.viewmodel.carouselImages.indexOf(this.viewmodel.selectedImage());
    }

    setSelectedImage(url) {
        this.$selectedImage.setAttribute('srcset', `${url}?w=${IMAGE_WIDTH} 1x, ${url}?w=${IMAGE_WIDTH * 2} 2x`);
        this.$selectedImage.src = `${url}?width=${IMAGE_WIDTH}`;
        this.$selectedImage.dataset.image = url;
    }

    destroy() {
        this.$container.innerHTML = '';
        this.selectedImageSubscription.dispose();
    }
}

export default ImageControlLarge;
